import { AxiosResponse } from 'axios'
import { ServiceDependencies } from 'lib/core/services/magento'
import { axiosClient } from 'lib/core/services/magento/client'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface GetProductAttributeListQueryObject {
  getProductAttributeList: {
    items: {
      attribute_code: boolean
      default_frontend_label: boolean
      frontend_input: boolean
      options: {
        label: boolean
        value: boolean
      }
    }
  }
}

export const getProductAttributeListQueryObject: GetProductAttributeListQueryObject = {
  getProductAttributeList: {
    items: {
      attribute_code: true,
      default_frontend_label: true,
      frontend_input: true,
      options: {
        label: true,
        value: true
      }
    }
  }
}

export type GetProductsAttributeListQuery = () => Promise<AxiosResponse<any>>

export const createGetProductsAttributeListQuery = ({ getQueries }: ServiceDependencies): GetProductsAttributeListQuery => async () => {
  const query = getQueries().getProductAttributeListQuery

  return axiosClient(jsonToGraphQLQuery(query), true)
}
